var _mask, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconPersonFull(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 26,
    viewBox: "0 0 23 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_1839_2721",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.5026 14.8896C15.4623 14.8896 18.6722 11.5565 18.6722 7.44481C18.6722 3.33316 15.4623 0 11.5026 0C7.54296 0 4.33303 3.33316 4.33303 7.44481C4.33303 11.5565 7.54296 14.8896 11.5026 14.8896Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 26C0 18.8042 5.14645 10.8072 11.5026 10.8072C17.8588 10.8072 23.0052 18.8042 23.0052 26"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5026 14.8896C15.4623 14.8896 18.6722 11.5565 18.6722 7.44481C18.6722 3.33316 15.4623 0 11.5026 0C7.54296 0 4.33303 3.33316 4.33303 7.44481C4.33303 11.5565 7.54296 14.8896 11.5026 14.8896Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 26C0 18.8042 5.14645 10.8072 11.5026 10.8072C17.8588 10.8072 23.0052 18.8042 23.0052 26",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6722 7.44481C17.6722 11.04 14.8748 13.8896 11.5026 13.8896V15.8896C16.0497 15.8896 19.6722 12.0729 19.6722 7.44481H17.6722ZM11.5026 13.8896C8.13042 13.8896 5.33303 11.04 5.33303 7.44481H3.33303C3.33303 12.0729 6.9555 15.8896 11.5026 15.8896V13.8896ZM5.33303 7.44481C5.33303 3.8496 8.13042 1 11.5026 1V-1C6.9555 -1 3.33303 2.81671 3.33303 7.44481H5.33303ZM11.5026 1C14.8748 1 17.6722 3.8496 17.6722 7.44481H19.6722C19.6722 2.81671 16.0497 -1 11.5026 -1V1ZM1 26C1 22.622 2.21465 19.0259 4.18007 16.2884C6.15427 13.5386 8.76401 11.8072 11.5026 11.8072V9.80716C7.88505 9.80716 4.74348 12.0743 2.55542 15.122C0.358574 18.1819 -1 22.1823 -1 26H1ZM11.5026 11.8072C14.2412 11.8072 16.8509 13.5386 18.8251 16.2884C20.7906 19.0259 22.0052 22.622 22.0052 26H24.0052C24.0052 22.1823 22.6466 18.1819 20.4498 15.122C18.2617 12.0743 15.1202 9.80716 11.5026 9.80716V11.8072Z",
    fill: "currentColor",
    mask: "url(#path-1-inside-1_1839_2721)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPersonFull);
export default __webpack_public_path__ + "static/media/icon_person_full.78ded7a15bd39f42ae0c94c75c9136e3.svg";
export { ForwardRef as ReactComponent };